import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { Dialog } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';

import { YButton } from '@core/components/y-button/y-button';

import { LocalSignInDialogService } from './local-sign-in-dialog.service';

/**
 * The developer local sign-in prompt (MLP-1517 / MLP-1877 L.3): an Entra object id (GUID) to mint a local producer
 * token for. Rendered once at the app root; opened and awaited by the LocalAuthProvider through
 * LocalSignInDialogService. Carries data-testids so the local-dev sign-in is e2e-drivable (the gateway-less CI path).
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'yt-local-sign-in-dialog',
  templateUrl: './local-sign-in-dialog.html',
  styleUrls: ['./local-sign-in-dialog.scss'],
  imports: [Dialog, InputText, YButton, PrimeTemplate],
  standalone: true
})
export class LocalSignInDialog {
  readonly service = inject(LocalSignInDialogService);
  readonly identity = signal('');

  submit(): void {
    const identity = this.identity().trim();
    if (!identity) return;
    this.identity.set('');
    this.service.submit(identity);
  }

  cancel(): void {
    this.identity.set('');
    this.service.cancel();
  }
}
